import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { AccessCodeTextInput } from '@instructure/quiz-core';
import { Text } from '@instructure/ui-text';
import t from '@instructure/quiz-i18n/format-message';
import { Setting } from '../Setting';
export var StudentAccessCode = /*#__PURE__*/function (_Component) {
  function StudentAccessCode() {
    var _this2;
    _classCallCheck(this, StudentAccessCode);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, StudentAccessCode, [].concat(args));
    // =============
    //    ACTIONS
    // =============
    _defineProperty(_this2, "toggleStudentAccessCode", function (event, changeCompleteCb) {
      var _this2$props = _this2.props,
        setRequireStudentAccessCode = _this2$props.setRequireStudentAccessCode,
        activeQuizId = _this2$props.activeQuizId;
      setRequireStudentAccessCode(activeQuizId, event.target.checked, changeCompleteCb);
    });
    _defineProperty(_this2, "updateAccessCodeApi", debounce(function (changeCompleteCb) {
      var _this2$props2 = _this2.props,
        setStudentAccessCodeApi = _this2$props2.setStudentAccessCodeApi,
        activeQuizId = _this2$props2.activeQuizId;
      setStudentAccessCodeApi(activeQuizId, _this2.accessCodeInput.value, changeCompleteCb);
    }, 300));
    _defineProperty(_this2, "setNewAccessCode", function (changeCompleteCb) {
      return function (event) {
        var _this2$props3 = _this2.props,
          setStudentAccessCodeUi = _this2$props3.setStudentAccessCodeUi,
          activeQuizId = _this2$props3.activeQuizId;
        setStudentAccessCodeUi(activeQuizId, _this2.accessCodeInput.value);
        _this2.updateAccessCodeApi(changeCompleteCb);
      };
    });
    _defineProperty(_this2, "setTextInputRef", function (ti) {
      _this2.accessCodeInput = ti;
    });
    return _this2;
  }
  _inherits(StudentAccessCode, _Component);
  return _createClass(StudentAccessCode, [{
    key: "studentAccessCode",
    value: function studentAccessCode() {
      return this.props.studentAccessCode || '';
    }
  }, {
    key: "render",
    value:
    // =============
    //   RENDERING
    // =============

    function render() {
      var _this3 = this;
      return /*#__PURE__*/React.createElement(Setting, {
        automationData: "sdk-accessCode-toggle",
        isChecked: this.props.requireStudentAccessCode,
        showMore: this.props.requireStudentAccessCode,
        label: t('Require a student access code'),
        onChange: this.toggleStudentAccessCode
      }, function (changeCompleteCb) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(AccessCodeTextInput, {
          inputRef: _this3.setTextInputRef,
          value: _this3.studentAccessCode(),
          placeholder: t('Password'),
          onChange: _this3.setNewAccessCode(changeCompleteCb),
          "data-automation": "sdk-accessCode-textBox"
        }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Text, {
          weight: "light",
          color: "secondary",
          size: "small"
        }, t('Leave blank for no access code')));
      });
    }
  }]);
}(Component);
_defineProperty(StudentAccessCode, "propTypes", {
  activeQuizId: PropTypes.string.isRequired,
  requireStudentAccessCode: PropTypes.bool.isRequired,
  setStudentAccessCodeApi: PropTypes.func.isRequired,
  setStudentAccessCodeUi: PropTypes.func.isRequired,
  setRequireStudentAccessCode: PropTypes.func.isRequired,
  studentAccessCode: PropTypes.string
});
_defineProperty(StudentAccessCode, "defaultProps", {
  studentAccessCode: ''
});
export default StudentAccessCode;